import React, { useEffect, useState, useRef } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import Button from 'react-bootstrap-button-loader';
import styles from '../../../../styles/profile.module.css';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import TextField from "@material-ui/core/TextField";
import { toEmpty } from '../../../../utils';
import { saveMedical, getInfoEmployee } from '../../../../actions/myFile/profile';
import * as StatusCode from '../../../../scripts/StatusCode';

import AlertAlgo from '../../../controls/AlertSnack'
import LoadingLayer from '../../../controls/LoadingLayer';

import { withNamespaces } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    form: {
        padding: '15px'
    },
    rootProfile: {
        overflow: 'auto'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    divSwitch: {
        marginTop: '15px',
        '& > label': {
            marginLeft: '0px'
        }
    },
    divButtons: {
        textAlign: 'center',
        marginTop: '15px'
    }
}));

function MedicalForm(props) {
    const classes = useStyles();

    const [data, setData] = useState([]);
    const [handicaps, setHandicaps] = useState('');
    const [allergies, setAllergies] = useState('');
    const [conditions, setConditions] = useState('');
    const [conditionsConfidential, setConditionsConfidential] = useState(false);
    const [others, setOthers] = useState('');
    const [othersConfidential, setOthersConfidential] = useState(false);
    const [isProcessing, setIsProcessing] = useState(true);

    const alertRef = useRef(null);

    useEffect(() => {
        loadEmployeeInfo();
        resize();
    }, []);

    useEffect(() => {
        handleDataChanged();
    }, [handicaps, allergies, conditions, conditionsConfidential, others, othersConfidential]);

    useEffect(() => {
        if (data.distriTypeSlip != null) {
            setHandicaps(data.handicap);
            setAllergies(data.allergie);
            setConditions(data.conditionMedicalSection);
            setConditionsConfidential(data.isConditionMedicalSectionConfidential == 'O');
            setOthers(data.otherMedicalSection);
            setOthersConfidential(data.isOtherMedicalSectionConfidential == 'O');

            handleDataChanged();
            setIsProcessing(false);
        }
    }, [data]);

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const offSet = 50;

            const customHeight = height - titleBar - offSet;

            const element = document.querySelector('#divProfile');

            if (element !== undefined && element !== null) {
                element.style.height = `${customHeight}px`;
            }
        }, 0);
    }

    const loadEmployeeInfo = () => {
        getInfoEmployee().then(response => {
            setData(response.employee);
        });
    }

    const handleDataChanged = () => {
        props.handleDataChanged(isDataChanged());
    }

    const isDataChanged = () => {
        const originalData = data;

        const stringOriginal = `${toEmpty(originalData.handicap)}${toEmpty(originalData.allergie)}${toEmpty(originalData.conditionMedicalSection)}
${originalData.isConditionMedicalSectionConfidential == 'O'}${toEmpty(originalData.otherMedicalSection)}
${originalData.isOtherMedicalSectionConfidential == 'O'}`;

        const stringNew = `${toEmpty(handicaps)}${toEmpty(allergies)}${toEmpty(conditions)}
${conditionsConfidential}${toEmpty(others)}
${othersConfidential}`;

        const isValid = stringOriginal != stringNew;

        return isValid;
    }

    const isValidData = () => {
        let message = '';

        if (!isDataChanged()) {
            message = i18next.t('profile:message.noModification');
        }

        if (message.length > 0) {
            showMessageError(message);
            return false;
        }

        return true;
    }

    const handleChangeHandicaps = (event) => {
        setHandicaps(event.target.value);
    }

    const handleChangeAllergies = (event) => {
        setAllergies(event.target.value);
    }

    const handleChangeConditions = (event) => {
        setConditions(event.target.value);
    }

    const handleChangeConditionsConfidential = (event) => {
        setConditionsConfidential(event.target.checked);
    }

    const handleChangeOthers = (event) => {
        setOthers(event.target.value);
    }

    const handleChangeOthersConfidential = (event) => {
        setOthersConfidential(event.target.checked);
    }

    const handleSave = () => {
        if (isValidData()) {
            saveMedical(handicaps, allergies, conditions, conditionsConfidential, others, othersConfidential).then(response => {
                if (response != null && response.status == StatusCode.STATUS_OK) {
                    showMessageSuccess(i18next.t('profile:medical.message.success'));
                    loadEmployeeInfo();
                    return;
                }
                showMessageError(i18next.t('error:generic-error'));
            });
        }
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }


    return (
        <LoadingLayer isActive={isProcessing}>
            <div className={classes.form + ' ' + styles.rootProfile}>
                <FormControl fullWidth>
                    <TextField
                        id="handicaps"
                        label={i18next.t('profile:medical.form.handicaps')}
                        value={handicaps || ''}
                        onChange={handleChangeHandicaps}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="allergies"
                        label={i18next.t('profile:medical.form.allergies')}
                        value={allergies || ''}
                        onChange={handleChangeAllergies}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="conditions"
                        label={i18next.t('profile:medical.form.conditions')}
                        value={conditions || ''}
                        onChange={handleChangeConditions}
                    />
                </FormControl>

                <FormControl className={classes.divSwitch}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={conditionsConfidential || false}
                                onChange={handleChangeConditionsConfidential}
                                name="conditionsConfidential"
                                variant="success"
                            />
                        }
                        label={i18next.t("profile:medical.form.conditionsConfidential")}
                        labelPlacement="start"
                    />
                </FormControl>

                <FormControl fullWidth>
                    <TextField
                        id="others"
                        label={i18next.t('profile:medical.form.others')}
                        value={others || ''}
                        onChange={handleChangeOthers}
                    />
                </FormControl>

                <FormControl className={classes.divSwitch}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={othersConfidential || false}
                                onChange={handleChangeOthersConfidential}
                                name="othersConfidential"
                                variant="success"
                            />
                        }
                        label={i18next.t("profile:medical.form.othersConfidential")}
                        labelPlacement="start"
                    />
                </FormControl>
                <div className="formDivButtons">
                    <Button onClick={handleSave} variant="success" className="saveButton">
                        {i18next.t('buttons:save')}
                    </Button>
                </div>
                <AlertAlgo ref={alertRef} />
            </div>
        </LoadingLayer>
    );
}

export default withNamespaces(['Language', 'profile', 'buttons'], { wait: true })(MedicalForm);